import React, { Component } from 'react';
import Cropper from 'react-easy-crop';
import { Modal, ModalHeader, ModalBody, Button, ModalFooter } from 'reactstrap';
import MaterialIcon from 'material-icons-react';
import i18n from '../../i18next';

class CropImageModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            crop: {
                image: null,
                crop: { x: 0, y: 0 },
                zoom: 1,
                cropSize: { width: 0, height: 0 },
                croppedAreaPixels: null,
            }
        }
    }

    componentDidMount = () => {
        this.setState({
            ...this.state,
            crop: this.props.crop
        });
    }

    onCropChange = (crop) => {
        this.setState({
            ...this.state,
            crop: { ...this.state.crop, crop }
        });
    }

    onCropComplete = (croppedArea, croppedAreaPixels) => {
        this.setState({
            ...this.state,
            crop: { ...this.state.crop, croppedAreaPixels }
        });
    }

    onZoomChange = (zoom) => {
        this.setState({
            ...this.state,
            crop: { ...this.state.crop, zoom }
        });
    }

    onZoomIn = () => {
        if (this.state.crop.zoom + 0.265 > 5) {
            this.setState({
                ...this.state,
                crop: { ...this.state.crop, zoom: 5 }
            });
        } else {
            this.setState({
                ...this.state,
                crop: { ...this.state.crop, zoom: this.state.crop.zoom + 0.265 }
            });
        }
    }

    onZoomOut = () => {
        if (this.state.crop.zoom - 0.265 < 1) {
            this.setState({
                ...this.state,
                crop: { ...this.state.crop, zoom: 1 }
            });
        } else {
            this.setState({
                ...this.state,
                crop: { ...this.state.crop, zoom: this.state.crop.zoom - 0.265 }
            });
        }
    }

    onCloseCropImage = () => {
        this.setState({
            ...this.state,
            crop: { ...this.state.crop, image: null },
        }, () => this.props.toggle());
    }

    renderModalBody() {
        const { zoomInButton, zoomOutButton } = styles;
        return (
            <ModalBody>
                <div style={{ width: this.state.crop.cropSize.width, height: this.state.crop.cropSize.height }}>
                    <Cropper
                        image={this.state.crop.image}
                        crop={this.state.crop.crop}
                        cropSize={this.state.crop.cropSize}
                        zoom={this.state.crop.zoom}
                        maxZoom={5}
                        minZoom={1}
                        onCropChange={this.onCropChange}
                        onCropComplete={this.onCropComplete}
                        onZoomChange={this.onZoomChange}
                        // restrictPosition={false}
                        showGrid={false}
                        style={{
                            containerStyle: {
                                width: this.state.crop.cropSize.width,
                                height: this.state.crop.cropSize.height,
                                top: '1rem',
                                left: '1rem',
                                border: '2px dashed red',
                                background: 'lightgray'
                            }
                        }}
                    />
                </div>
                <div style={styles.buttonsContainer}>
                    <div style={zoomInButton} onClick={() => this.onZoomIn()}>+</div>
                    <div style={zoomOutButton} onClick={() => this.onZoomOut()}>-</div>
                </div>
            </ModalBody>
        );
    }

    renderModalFooter() {
        return (
            <div>
                <Button color="primary" onClick={() => this.onCloseCropImage()} >
                    <span style={{ marginLeft: 4 }}><MaterialIcon icon="crop_original" color="#fff" size={19} /> </span>
                    {i18n.t('common:buttons.keepOriginalSize')}
                </Button>
                <Button color="primary" onClick={() => this.props.onClickSave(this.state.crop)} style={{ marginLeft: 10 }}>
                    <span style={{ marginRight: 4 }}><MaterialIcon icon="content_cut" color="#fff" size={20} /></span>
                    {i18n.t('common:buttons.cropImage')}
                </Button>
            </div>
        )
    }

    render() {
        return (
            <Modal isOpen={this.props.isOpen} toggle={() => this.onCloseCropImage()} className={this.props.modalClass} >
                <ModalHeader toggle={() => this.onCloseCropImage()}>
                    {i18n.t('common:buttons.cropImage')}
                </ModalHeader>
                {this.renderModalBody()}
                <ModalFooter>
                    {this.renderModalFooter()}
                </ModalFooter>
            </Modal>
        )
    }
}

export default CropImageModal;

let styles = {
    buttonsContainer: {
        display: 'flex',
        position: 'absolute',
        left: 'calc(50% - 46px)',
        bottom: 50,
    },

    zoomInButton: {
        width: 40,
        height: 40,
        backgroundColor: 'black',
        opacity: 0.5,
        borderRadius: 20,
        color: 'white',
        textAlign: 'center',
        fontSize: 25,
        lineHeight: '36px',
        cursor: 'pointer',
        marginRight: 7
    },

    zoomOutButton: {
        width: 40,
        height: 40,
        backgroundColor: 'black',
        opacity: 0.5,
        borderRadius: 20,
        color: 'white',
        textAlign: 'center',
        fontSize: 25,
        lineHeight: '36px',
        cursor: 'pointer',
        marginLeft: 7
    }
}


// WEBPACK FOOTER //
// ./src/components/common/CropImageModal.js